import { render, staticRenderFns } from "./fileleDialog.vue?vue&type=template&id=c2848490&scoped=true"
import script from "./fileleDialog.vue?vue&type=script&lang=js"
export * from "./fileleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2848490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2848490')) {
      api.createRecord('c2848490', component.options)
    } else {
      api.reload('c2848490', component.options)
    }
    module.hot.accept("./fileleDialog.vue?vue&type=template&id=c2848490&scoped=true", function () {
      api.rerender('c2848490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/rmcDrugList/dialog/fileleDialog.vue"
export default component.exports